import React from 'react';
import { Heart, Home, LogOut, User } from 'lucide-react';
import { useApp } from '../context/AppContext';

const Header = () => {
  const { user, favorites, resetBooking, handleLogout, setShowAuthModal } = useApp();

  return (
    <header className="bg-gradient-to-r from-teal-600 via-teal-500 to-emerald-500 text-white shadow-lg">
      <div className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between">
        <div className="flex items-center gap-3 cursor-pointer" onClick={resetBooking}>
          <div className="bg-white/20 p-2 rounded-xl"><Home className="w-7 h-7" /></div>
          <div><h1 className="text-2xl font-bold">CareConnect</h1><p className="text-teal-100 text-xs">Home Health Professionals</p></div>
        </div>
        <nav className="flex items-center gap-4">
          <button className="flex items-center gap-2 px-4 py-2 bg-white/10 rounded-full hover:bg-white/20">
            <Heart className="w-4 h-4" /><span className="text-sm hidden sm:inline">Saved ({favorites.length})</span>
          </button>
          {user ? (
            <div className="flex items-center gap-3">
              <span className="text-sm hidden sm:inline">Hi, {user.firstName || user.first_name}</span>
              <button onClick={handleLogout} className="flex items-center gap-2 px-4 py-2 bg-white rounded-full text-teal-600 font-medium">
                <LogOut className="w-4 h-4" /><span className="text-sm">Logout</span>
              </button>
            </div>
          ) : (
            <button onClick={() => setShowAuthModal(true)} className="flex items-center gap-2 px-4 py-2 bg-white rounded-full text-teal-600 font-medium">
              <User className="w-4 h-4" /><span className="text-sm">Sign In</span>
            </button>
          )}
        </nav>
      </div>
    </header>
  );
};

export default Header;
